export default __webpack_public_path__ + "61d2ac49ee09cd457cf2e38ed54824ab.png";